import { render } from "./Home.vue?vue&type=template&id=61389950&scoped=true&lang=pug"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=61389950&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-61389950"

export default script